// extracted by mini-css-extract-plugin
export default {"fieldContainer":"link-container_fieldContainer__V++ZL","copyInputContainer":"link-container_copyInputContainer__tyh65","linkLabel":"link-container_linkLabel__tFryR"};